import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Clock, Sparkles } from "lucide-react";
import { categoryPath } from "@/lib/paths";

export const launchStatus = (cat) => cat?.launch_status || (cat?.is_coming_soon ? "coming_soon" : "active");

export function StatusLine({ cat, className = "" }) {
  const s = launchStatus(cat);
  if (s === "active") {
    return <span className={`inline-flex items-center gap-1.5 text-sm font-medium text-[#264839] ${className}`} data-testid={`cat-status-${cat.slug || cat.id}`}><CheckCircle2 className="w-4 h-4" /> Explore suppliers</span>;
  }
  if (s === "launching") {
    return <span className={`inline-flex items-center gap-1.5 text-sm font-medium text-[#B35C4A] ${className}`} data-testid={`cat-status-${cat.slug || cat.id}`}><Sparkles className="w-4 h-4" /> Launching now, suppliers joining</span>;
  }
  return <span className={`inline-flex items-center gap-1.5 text-sm text-[#7D8C85] ${className}`} data-testid={`cat-status-${cat.slug || cat.id}`}><Clock className="w-4 h-4" /> Coming soon</span>;
}

/** Two-column grid of large rounded photo cards — one per top-level category. No supplier counts anywhere. */
export default function CategoryGrid({ categories, testPrefix = "category-grid" }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-testid={testPrefix}>
      {categories.map((cat, i) => {
        const s = launchStatus(cat);
        const imgUrl = cat.image_url && cat.image_url.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${cat.image_url}` : cat.image_url;
        return (
          <Link
            key={cat.id}
            to={categoryPath(cat)}
            className="group block bg-white rounded-2xl overflow-hidden border border-[#E8ECE9] shadow-sm hover:shadow-lg hover:-translate-y-0.5 transition-[transform,box-shadow] duration-300 fade-up"
            style={{ animationDelay: `${i * 60}ms` }}
            data-testid={`${testPrefix}-card-${cat.slug || cat.id}`}
          >
            <div className="aspect-[16/9] bg-[#E8ECE9] overflow-hidden relative">
              {imgUrl && <img src={imgUrl} alt={cat.name} loading={i < 2 ? "eager" : "lazy"} className={`w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04] ${s === "coming_soon" ? "saturate-[0.75]" : ""}`} />}
            </div>
            <div className="p-5 sm:p-6">
              <h3 className={`font-serif text-xl sm:text-2xl tracking-tight ${s === "coming_soon" ? "text-[#4A5550]" : "text-[#11211A] group-hover:text-[#264839]"}`} data-testid={`${testPrefix}-name-${cat.slug || cat.id}`}>{cat.name}</h3>
              <StatusLine cat={cat} className="mt-2" />
            </div>
          </Link>
        );
      })}
    </div>
  );
}
